module.exports = __webpack_public_path__ + "static/media/sprite.91726854.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sprite.png
// module id = 914
// module chunks = 7